import { Fragment, useEffect } from 'react'
import { NextSeo } from 'next-seo'

import withPage from '@/lib/page/withPage'

import withServiceLayout from '@/features/Services/layouts/withServiceLayout'
import ServiceSection from '@/features/Services/templates/ServiceSection'
import PriceSection from '@/features/Services/templates/PriceSection'

import { WhatYouGet } from '@/components/Landing'

import { VENDOR } from '@/features/Services/constants'
import { logEcommerce } from '@/lib/stats/gtm'

function VendorPage() {
  useEffect(() => {
    logEcommerce('view_item', {
      items: [
        {
          item_id: 'Vendor Policy"',
          item_name: 'Vendor Policy"',
          quantity: 1,
        },
      ],
    })
  }, [])
  return (
    <Fragment>
      <NextSeo title="Vendor Policy" />

      <ServiceSection data={VENDOR} />
      <PriceSection serviceName="VENDOR" />
      <WhatYouGet hideDecor primaryColor={VENDOR.PRIMARY_COLOR} />
    </Fragment>
  )
}

export default withPage()(withServiceLayout(VendorPage))
